import { Helmet } from 'react-helmet-async';

function HomeHelmetComponent() {
  return (
    <Helmet>
      {/* Title ja Meta Description */}
      <title>Spiderlegs Productions | Tapahtumatekniikka & Esiintyjät</title>
      <meta
        name="description"
        content="Spiderlegs Productions tarjoaa tapahtumatekniikan palvelut, esiintyjät ja vuokrattavat laitteet juhliin, häihin ja yritystilaisuuksiin – kaikki yhdestä paikasta."
      />
      <meta
        name="keywords"
        content="tapahtumatekniikka, esiintyjät, bändit, vuokraus, äänentoisto, valaistus, juhlat, häät, yritystapahtumat, esitystekniikka, DJ, trubaduuri, bilebändi, coverbändi, hääbändi, kaiutin, mikseri, peräkärry, partyband, weddingband"
      />
      <meta name="author" content="Spiderlegs Productions" />

      {/* Canonical URL */}
      <link rel="canonical" href="https://spiderlegsproductions.com/" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Spiderlegs Productions | Tapahtumatekniikka & Esiintyjät"
      />
      <meta
        property="og:description"
        content="Tapahtumatekniikan palvelut, esiintyjät ja vuokrattavat laitteet juhliin, häihin ja yritystapahtumiin – kaikki yhdestä paikasta."
      />
      <meta
        property="og:image"
        content="https://spiderlegsproductions.com/assets/new_logo.webp"
      />
      <meta property="og:url" content="https://spiderlegsproductions.com/" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Spiderlegs Productions | Tapahtumatekniikka & Esiintyjät"
      />
      <meta
        name="twitter:description"
        content="Tapahtumatekniikan palvelut, esiintyjät ja vuokrattavat laitteet juhliin, häihin ja yritystapahtumiin – kaikki yhdestä paikasta."
      />
      <meta
        name="twitter:image"
        content="https://spiderlegsproductions.com/assets/new_logo.webp"
      />
    </Helmet>
  );
}

export default HomeHelmetComponent;
